/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompatibilityCheckResult
 */
export interface CompatibilityCheckResult {
    /**
     * Result of compatibility check.
     * @type {boolean}
     * @memberof CompatibilityCheckResult
     */
    compatible: boolean;
    /**
     * Message to show in case of not compatible products.
     * @type {string}
     * @memberof CompatibilityCheckResult
     */
    message: string;
}

/**
 * Check if a given object implements the CompatibilityCheckResult interface.
 */
export function instanceOfCompatibilityCheckResult(value: object): value is CompatibilityCheckResult {
    if (!('compatible' in value) || value['compatible'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function CompatibilityCheckResultFromJSON(json: any): CompatibilityCheckResult {
    return CompatibilityCheckResultFromJSONTyped(json, false);
}

export function CompatibilityCheckResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompatibilityCheckResult {
    if (json == null) {
        return json;
    }
    return {
        
        'compatible': json['compatible'],
        'message': json['message'],
    };
}

export function CompatibilityCheckResultToJSON(json: any): CompatibilityCheckResult {
    return CompatibilityCheckResultToJSONTyped(json, false);
}

export function CompatibilityCheckResultToJSONTyped(value?: CompatibilityCheckResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'compatible': value['compatible'],
        'message': value['message'],
    };
}

